import { useEffect } from 'react';

/**
 * Hook for setting a timeout
 *
 * @param callback - The callback to call after the timeout
 * @param ms - The timeout in milliseconds
 * @param args - The arguments to pass to the callback
 */
export default function useTimeout<Args extends unknown[]>(
  callback: (...args: Args) => void,
  ms: number,
  ...args: Args
) {
  useEffect(() => {
    const timeout = setTimeout(callback, ms, ...args);

    return () => clearTimeout(timeout);
  }, [callback, ms, args]);
}
